import React from 'react';
import { Label } from '../ui/label';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '../ui/select';

export const NO_COLLABORATOR = 'none';

export const PropertyCollaboratorField = ({ team, value, onChange }) => {
  const active = team.collaborators.filter((c) => c.is_active);
  return (
    <div className="space-y-2 border border-slate-200 bg-slate-50/70 p-4" data-testid="property-collaborator-section">
      <Label className="text-xs text-slate-500" htmlFor="property-collaborator-select">Collaboratore responsabile (facoltativo)</Label>
      {active.length ? (
        <Select value={value} onValueChange={onChange}>
          <SelectTrigger id="property-collaborator-select" data-testid="property-collaborator-select"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value={NO_COLLABORATOR} data-testid="property-collaborator-option-none">Nessun collaboratore</SelectItem>
            {active.map((c) => (
              <SelectItem key={c.id} value={c.id} data-testid={`property-collaborator-option-${c.id}`}>{c.first_name} {c.last_name}</SelectItem>
            ))}
          </SelectContent>
        </Select>
      ) : (
        <p className="text-sm text-slate-500" data-testid="property-collaborator-empty">Non hai ancora collaboratori attivi. Puoi aggiungerli dalla pagina Collaboratori.</p>
      )}
      <p className="text-[11px] leading-4 text-slate-500" data-testid="property-collaborator-help">Un solo collaboratore per immobile. Riceve un’email quando gli assegni l’immobile e quando glielo togli.</p>
    </div>
  );
};
